import { useLocalStorage } from 'usehooks-ts'

export function useLoginFromCart() {
    const [isNewLogin, setIsNewLogin] = useLocalStorage<boolean>('is-new-login', false)

    return { isNewLogin, setIsNewLogin }
}
